import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ThirdPartyService } from '../../third-party.service';
import { HttpErrorResponse } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import { PrivilegesService } from 'src/app/services/privileges.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FeatureFlagService } from 'src/app/services/feature-flag.service';
import { LayoutService } from 'src/app/layout/layout.service';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-service-add',
  templateUrl: './service-add.component.html',
  styleUrls: ['./service-add.component.scss']
})
export class ServiceAddComponent implements OnInit , OnDestroy {
  toolbarData: any = {};
  jobDetailForm!: FormGroup;
  branchID: any = 0;
  userID: any = 0;
  shopList: any[] = [];
  shopBranchID: any = 0;
  date: any;
  userList: any[] = [];
  currentAssignedUser: any;
  currentShop: any;
  deviceTypes: any[] = [];
  modelNames: any[] = [];
  phoneNames: any[] = [];
  showPaymentModesModal: boolean = false;
  showAdvancePaymentModal: boolean = false;
  recievedAdvanceAmount: number = 0;
  paymentInfo: any;
  defaultProduct: any;
  internalWorkCode: any;
  defaultProductPrice: number = 0;
  workId: any = 0;
  SalesPOSUserID: any;
  CustomerName: any;
  CustomerPhone: any;
  isSubmitAdvancePay: boolean = false;
  isAdvanceInvalid: boolean;
  isCostAndPaymentEnabledSeller: boolean = false
  isApiCalling: boolean = false;

  // for tost msg
  notificationMsg = '';
  showToast: boolean = false;
  isSuccess: boolean;
  isExpressjob: boolean = false;
  showExpressJobBanner: boolean = true;
  showCollectedAmtPaymentModal: boolean = false;
  calledFrom: 'advance' | 'collected-amt' = 'advance'; 
  recievedCollectedAmount: number = 0;
  accessoriesConfig : any= {
    accessoriesProvided: [],
    accessoriesMissing: []
  };
  pass: number = 2;

  constructor(private fb: FormBuilder,
    private thirdPartyService: ThirdPartyService,
    private privilegeService: PrivilegesService,
    private router: Router,
    private route: ActivatedRoute,
    private featureFlagService: FeatureFlagService,
    private layoutService: LayoutService,
    private configService: ConfigService
  ) { 
  }

  ngOnInit() {
    
    this.isCostAndPaymentEnabledSeller = this.featureFlagService.getFeatureStatus('service_job_with_accounts', false)
    this.privilegeService.getUserPrivileges();
    this.getUserAndBranchID();
    this.loadFromStorage();
    this.getFormValueSuggesstions();
    const jobType = this.route.snapshot.paramMap.get('jobtype');
    if(jobType){
      this.isExpressjob = true;
    }
    this.populateToolbarData();

    this.setAllForms();
    this.GetThirdPartySettings();
    

    // Listen to Shop field changes
    this.jobDetailForm.get('Shop')?.valueChanges.subscribe(shopValue => {
      const shopNameControl = this.jobDetailForm.get('ShopName');
      if (shopValue) {
        shopNameControl?.setValidators([Validators.required]);
      } else {
        shopNameControl?.clearValidators();
      }
      shopNameControl?.updateValueAndValidity();
    });
    window.scrollTo(0, 0); // Reset the scroll to top

    const expressJobBannerFlag = localStorage.getItem('expressjob-banner-hidden');
    if(expressJobBannerFlag === 'true'){
      this.showExpressJobBanner = false;
    }
  }

  ngOnDestroy() {
    this.jobDetailForm.reset(); 
  }

  public getUserAndBranchID() {
    this.thirdPartyService.getStaffIdAndBrandchId().subscribe((res: any) => {
      if (res && res?.Result == "Success" && res?.ResponseData) {
        let response = res?.ResponseData
        this.branchID = response.BranchId
        this.userID = response.UserId;
        this.getShops();
        this.getUsers();
      }
    }, (error: HttpErrorResponse) => {
    });
  }

  private populateToolbarData() {
    let jobTitle = 'Add Service';
    if(this.isExpressjob){
      jobTitle = 'Express Job'
    }

    this.layoutService.setToolbar({
      title: jobTitle,
    });

    this.layoutService.setNavbarButtons([]);

  }

  private setAllForms() {
    this.date = new Date();
    this.date.setHours(17, 30, 0, 0);
    this.jobDetailForm = this.fb.group({
      Shop: [false],
      ShopName: [null],
      DeviceType: [null],
      Brand: [null],
      ModelName: [null, Validators.required],
      Imei: [''],
      Passcode: [''],
      patternlock: [''],
      WorkDescription: ['', Validators.required],
      DeliveryDate: [this.formatDateForInput(this.date), Validators.required],
      deviceColor: [''],
      CustomerDescription: [''],
      MinCost: [''],
      MaxCost: [''],
      AdvanceCollected: [''],
      collectedAmount: [null],
      AssignTo: [null],
      ContactPerson: [''],
      ContactNo: [''],
      EmailID: [''],
      ContactAddress: [''],
    })

    const passcodeControl = this.jobDetailForm.get('Passcode');
    const patternControl = this.jobDetailForm.get('patternlock');

    passcodeControl?.valueChanges.subscribe(value => {
      if (value) {
        patternControl?.setValue('', { emitEvent: false });
      }
    });

    patternControl?.valueChanges.subscribe(value => {
      if (value) {
        passcodeControl?.setValue('', { emitEvent: false });
      }
    });

  }

  onPatternComplete(pattern: number[]) {
    this.jobDetailForm.get('patternlock')?.setValue(pattern);
  }

  get advanceAmountValue(): number {
    return Number(this.jobDetailForm.get('AdvanceCollected').value) || 0;
  }

  get collectedAmountValue(): number {
    return Number(this.jobDetailForm.get('collectedAmount').value) || 0;
  }

  public saveJob() {
    this.isApiCalling = true;
    const accessoriesData = this.jobDetailForm.get('accessories')?.value;
    let accessoriesDataString = '';
    if(accessoriesData){
      accessoriesData.PatternLock = this.jobDetailForm.get('patternlock')?.value;
      accessoriesDataString = JSON.stringify(accessoriesData);
    }
    let devicePass;
    if(this.jobDetailForm.get('patternlock')?.value){
      devicePass = {
        pat: this.jobDetailForm.get('patternlock')?.value
      }  
    }else if(this.jobDetailForm.value.Passcode){
      devicePass = {
        pas: this.jobDetailForm.value.Passcode
      }
    }
    if (this.jobDetailForm.valid) {
      let params = {
        id: "",
        branchID: this.branchID,
        branchName: "",
        createdBy: this.userID,
        manufactureName: this.jobDetailForm.value.Brand,
        modelName: this.jobDetailForm.value.ModelName,
        workCaption: "",
        workDescription: this.jobDetailForm.value.WorkDescription,
        workStatus: "Created",
        createdOn: "",
        deliveryDate: this.jobDetailForm.value.DeliveryDate,
        updatedOn: "",
        imei: this.jobDetailForm.value.Imei,
        contactPerson: '',
        contactNo: '',
        issms: false,
        emailID: this.jobDetailForm.value.EmailID,
        contactAddress: this.jobDetailForm.value.ContactAddress,
        accessories: accessoriesDataString, //pass as an string of object
        selectedItem: "",
        selectedItem1: "",
        pattern: devicePass ? JSON.stringify(devicePass): '',
        shopName: '',
        minServiceCost: this.jobDetailForm.value.MinCost,
        maxServiceCost: this.jobDetailForm.value.MaxCost,
        advanceServiceCost: this.jobDetailForm.value.AdvanceCollected,
        forCompany: "",
        assignedUserID: 0,
        assignedUser: '',
        deviceType: this.jobDetailForm.value.DeviceType,
        branchType: "Mobile",
        isBooking: false,
        bookingID: 0,
        deviceImage: "",
        approvedAmount: 0,
        cost: 0,
        payment: 0,
        discount: 0,
        balance: 0,
        emitionBenchMark: "",
        yearOfManufacture: "",
        isWhatsappEnabled: false
      }
      if (this.jobDetailForm.get('Shop')?.value) {
        this.currentShop = this.shopList.find(item => item.BranchID == this.jobDetailForm.get('ShopName')?.value);
        params.shopName = this.currentShop.ShopName;
        params.branchID = this.currentShop.BranchID;
      } else {
        params.contactPerson = this.jobDetailForm.value.ContactPerson;
        params.contactNo = this.jobDetailForm.value.ContactNo;
      }
      if (this.jobDetailForm.value.AssignTo) {
        this.currentAssignedUser = this.userList.find(item => item.UserID == this.jobDetailForm.value.AssignTo);
        params.assignedUser = this.currentAssignedUser.Name;
        params.assignedUserID = this.currentAssignedUser.UserID;
      }
      this.thirdPartyService.insertWorkOrderWithBranchType(params).subscribe((res: any) => { 
        if (res && res?.Result == "Success" && res?.ResponseData && res?.ResponseData != "Usage Limit Exceeded") {
          this.notify(true, "Job created successfully");
          const str = res?.ResponseData
          this.internalWorkCode = Number(str.split(',')[1]);
          this.workId = Number(str.split(',')[2]);
          if (this.recievedAdvanceAmount > 0 || this.recievedCollectedAmount > 0) { 
            this.getServiceProduct();
          }  
           this.jobDetailForm.reset(); 
           setTimeout(() => {
               const { thirdpartyuserkey, thirdpartyappurl } = this.route.snapshot.queryParams;
               this.router.navigate(['servicenear/dashboard'], {
                 queryParams: { thirdpartyuserkey, thirdpartyappurl }
               });
             
          },1500);
        } else if(res?.ResponseData == "Usage Limit Exceeded"){
          this.notify(false, "monthly usage limit exceeded. Please contact support");
        } else {
          this.notify(false, 'Job creation failed, try again later.');
        }
        this.isApiCalling = false;
      }, (error: HttpErrorResponse) => {
        this.isApiCalling = false;
        this.notify(false, 'Job creation failed, try again later.'); 
      })
      if (this.recievedAdvanceAmount > 0 || this.recievedCollectedAmount > 0) {
        this.defaultProductPrice = this.jobDetailForm.value.MaxCost;
        if (this.jobDetailForm.get('Shop')?.value) {
          this.currentShop = this.shopList.find(item => item.BranchID == this.jobDetailForm.get('ShopName')?.value);
          this.CustomerName = this.currentShop.ShopName;
          this.CustomerPhone = '';
          this.SalesPOSUserID = this.currentShop.SalesPOSUserID;
        } else {
          this.SalesPOSUserID = 0;
          this.CustomerName = this.jobDetailForm.value.ContactPerson;
          this.CustomerPhone = this.jobDetailForm.value.ContactNo;
        }
      }
    } else {
      this.isApiCalling = false;
      this.notify(false, 'Please fill all the required fields to save the job.');
    }
  }

  private getServiceProduct() { 

    const paramsService = {
      takeAll: true,
      skip: 0,
      take: 50,
      categoryID: 0,
      keyword: '',
      productsFor: 'admin',
      productsType: 'service',
      organisationID: 0,
      ShowInactiveProductsOnly: false,
      ShowUnpublishedProductsOnly: false,
      ShowOutOfStockProductsOnly: false
    };
    this.thirdPartyService.getProductList(paramsService).subscribe((res: any) => {
      if (res && res?.Result == "Success" && res?.ResponseData) {
        const serviceProducts = res.ResponseData;
        if (serviceProducts?.length > 0) {
          this.defaultProduct = serviceProducts[0];
          if (this.defaultProductPrice) {
            this.defaultProduct.FinalPrice = this.defaultProductPrice;
          } else {
            this.defaultProduct.FinalPrice = this.recievedAdvanceAmount
          }

          this.createSalesOrderForAdvance();
        }
      }
    }, (error: HttpErrorResponse) => {
      // this.isLoading = false;
    });
  }

  public createSalesOrderForAdvance() { 

    let orderDetailsArray = [{
      userID: this.SalesPOSUserID || 0,
      productID: this.defaultProduct.ID || this.defaultProduct.ProductID,
      price: Number(this.defaultProductPrice || this.recievedAdvanceAmount),
      quantity: 1,
      createdBy: this.SalesPOSUserID || 0,
      organisationID: 0,
      unknownUserKey: ''
    }];

    if (this.calledFrom === 'collected-amt') {
      orderDetailsArray[0].price = this.recievedCollectedAmount;
    }

    var sendingDataP = {
      orderHeader: {
        totalDeliveryCharge: 0,
        grandTotalAmount: 0,
        productTotalAmount: Number(this.defaultProduct.FinalPrice),
        CustomerName: this.CustomerName,
        CustomerPhone: this.CustomerPhone,
        DeliveryAddress: '',
        DeliveryPlace: '',
        DeliveryLandMark: '',
        DeliveryPincode: '',
        pickFromDeliveryPlace: false,
        ItemsCount: 1,
        paymentType: 'COD',
        discountBreakdown: '',
        appliedDiscount: 0,
        updateThirdPartyOrder: true,
        serviceCost: Number(this.defaultProduct.FinalPrice),
        partsQty: 0,
        partsCost: 0,
        branchId: String(this.branchID),
        workId: this.workId,
        userID: this.SalesPOSUserID,
        changeToReturned: this.paymentInfo.change,
        totalReceivedAmount: this.paymentInfo.totalCashReceived,
        orderStatus: 'Placed',
        paymentModes: this.paymentInfo.paymentModesString,
        advanceAmount: this.recievedAdvanceAmount,
        saleType: 'service'
      },
      orderDetails: orderDetailsArray
    };

    if (this.calledFrom === 'collected-amt') {
      sendingDataP.orderHeader.productTotalAmount = this.recievedCollectedAmount;
      sendingDataP.orderHeader.serviceCost = this.recievedCollectedAmount;
      sendingDataP.orderHeader.advanceAmount = 0;
      sendingDataP.orderHeader.orderStatus = 'Delivered';
    }


    this.isApiCalling = true;
    this.thirdPartyService.CheckOutOrderForPOS(sendingDataP).subscribe(
      (res: any) => {
        if (res?.Result === 'Success' && res?.ResponseData.OrderNumber) {
          const OrderID = res?.ResponseData?.OrderID;
          this.updateSalesPOSOrderID(this.workId, OrderID);
          if (this.calledFrom === 'collected-amt') {
            this.updateWorkStatus();
          }
          const { thirdpartyuserkey, thirdpartyappurl } = this.route.snapshot.queryParams;
          this.router.navigate(['servicenear/dashboard'], { queryParams: { thirdpartyuserkey, thirdpartyappurl } });
        }
        this.isApiCalling = false;
      },
      (error: any) => {
        this.notify(false, 'Advance add failed, try editing the job.');
        this.isApiCalling = false;
      }
    );

  }

  public clearJob() {
    this.jobDetailForm.reset();
    this.clearUser();
  }

  public getUsers() {
    this.userParams.branchID = this.branchID;
    this.thirdPartyService.getBranchUsers(this.userParams).subscribe((res: any) => {
      if (res && res?.Result == "Success" && res?.ResponseData) {
        this.userList = res?.ResponseData
        localStorage.setItem('userList', JSON.stringify(this.userList));
      }
    },
      (error: HttpErrorResponse) => {
      });
  }

  public clearUser() {
    this.currentAssignedUser = '';
  }

  userParams = {
    key: "",
    takeAll: true,
    skip: 0,
    take: 0,
    isDateChecked: false,
    fromDate: "",
    toDate: "",
    branchID: "",
    userType: ""
  }

  private getShops() {
    this.thirdPartyService.getShops(this.userID).subscribe((res: any) => {
      if (res && res?.Result == "Success" && res?.ResponseData) {
        this.shopList = res?.ResponseData;
        localStorage.setItem('shopList', JSON.stringify(this.shopList));
      }
    }, (error: HttpErrorResponse) => {
      console.log(error);
    })
  }

  private formatDateForInput(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  private getFormValueSuggesstions() {
    this.thirdPartyService.getDeviceTypesByBranchType().subscribe((res: any) => {
      this.deviceTypes = res.ResponseData;
      localStorage.setItem('deviceTypes', JSON.stringify(this.deviceTypes));
    }, (error: HttpErrorResponse) => {
      console.log(error);
    });
    this.thirdPartyService.getPhoneModelNamesByBranchType().subscribe((res: any) => {
      this.modelNames = res.ResponseData;
      localStorage.setItem('modelNames', JSON.stringify(this.modelNames));
    }, (error: HttpErrorResponse) => {
      console.log(error);
    });
    this.thirdPartyService.getPhoneNamesByBranchType().subscribe((res: any) => {
      this.phoneNames = res.ResponseData;
      localStorage.setItem('phoneNames', JSON.stringify(this.phoneNames));
    }, (error: HttpErrorResponse) => {
      console.log(error);
    });
  }

  public addDeviceTypeTagFn(term: string) {
    return { DeviceType: term };
  }

  public addPhoneNamesTagFn(term: string) {
    return { BranchType: 'Computer', ManufactureName: term };
  }

  public addModelNamesTagFn(term: string) {
    return { BranchType: 'Computer', ModelName: term };
  }

  public openAdvancePaymentModal() {
    this.showAdvancePaymentModal = true;
  }

  public handleAdvanceConfirm() {
    this.showAdvancePaymentModal = false;
  }

  public openCollectedAmtPaymentModal() {
    this.showCollectedAmtPaymentModal = true;
  }

  public handleCollectedAmtConfirm() {
    this.showCollectedAmtPaymentModal = false;
  }

  public openPaymentModesModal(from: 'advance' | 'collected-amt' ) {
    this.calledFrom = from;
    this.showPaymentModesModal = true;
  }

  public handlePaymentModalClose() {
    this.showPaymentModesModal = false;
  }

  public handlePaymentSaved(event: { paymentModes: any[]; totalAmount: number; changeToReturn: number; totalCashReceived: number; calledFrom: 'advance' | 'collected-amt'; }) {

    const paymentModesString = JSON.stringify(event.paymentModes);
    const change = event.changeToReturn;
    const totalReceivedAmount = event.totalAmount;
    const totalCashReceived = event.totalCashReceived;
    this.paymentInfo = {
      change,
      paymentModesString,
      totalReceivedAmount,
      totalCashReceived
    }
    
    if (event.calledFrom == 'advance') {
      if (totalReceivedAmount) {
        this.recievedAdvanceAmount = totalReceivedAmount - change;
        this.jobDetailForm.get('AdvanceCollected').setValue(this.recievedAdvanceAmount);
        this.isSubmitAdvancePay = true;
      }
      this.handleAdvanceConfirm();
    }else if(event.calledFrom == 'collected-amt'){
      this.recievedCollectedAmount = this.jobDetailForm.value.collectedAmount;
      this.jobDetailForm.get('collectedAmount').setValue(this.recievedCollectedAmount);
      this.handleCollectedAmtConfirm();
    }
  }

  public validateAdvanceAmount() {
    const advance = Number(this.jobDetailForm.get('AdvanceCollected')?.value) || 0;
    const max = Number(this.jobDetailForm.get('MaxCost')?.value) || 0;
    if (max) {
      this.isAdvanceInvalid = advance > max;
    }
    return this.isAdvanceInvalid
  }

  private updateSalesPOSOrderID(workOrderId: number, salesPosOrderId: number,) {
    this.thirdPartyService.updateSalesPOSOrderID(workOrderId, salesPosOrderId).subscribe(
      (res: any) => {
        if (res?.Result === 'Success') {

        }
      })
  }

  private notify(status: boolean, msg: string) {
    this.showToast = true;
    this.isSuccess = status;
    this.notificationMsg = msg;
    setTimeout(() => {
      this.showToast = false;
    }, 2000);
  }

  private loadFromStorage() {
    const deviceTypes = localStorage.getItem('deviceTypes');
    const modelNames = localStorage.getItem('modelNames');
    const phoneNames = localStorage.getItem('phoneNames');
    const shopList = localStorage.getItem('shopList');
    const userList = localStorage.getItem('userList');

    if (deviceTypes) this.deviceTypes = JSON.parse(deviceTypes);
    if (modelNames) this.modelNames = JSON.parse(modelNames);
    if (phoneNames) this.phoneNames = JSON.parse(phoneNames);
    if (shopList) this.shopList = JSON.parse(shopList);
    if (userList) this.userList = JSON.parse(userList);
  }

  public hideExpressJobBannerForever(){
    this.showExpressJobBanner = false;
    localStorage.setItem('expressjob-banner-hidden', 'true');
  }

  public updateWorkStatus() {

    let updationParams = {
      id: this.workId,
      createdBy: String(this.userID),
      customerDescription: '',
      minServiceCost: 0,
      maxServiceCost: 0,
      workDescription: '',
      workStatus: 'Delivered',
      updatedOn: new Date(),
      branchID: String(this.branchID),
      serviceCost: this.recievedCollectedAmount,
      finalCost: 0,
      collectedPerson: '',
      collectedPersonNo: '',
      transferBranch: 0,
      transferType: '',
      branchType: 'Computer',
      partsCost:0,
      warrantyData: '',
      approvedAmount: 0,
      cost: this.recievedCollectedAmount,
      payment: 0,
      discount: 0,
      balance: 0,
      changeOnly: '',
      issms: true,
    };

    this.thirdPartyService
      .updateWorkOrderStatusByBranchType(updationParams)
      .subscribe(
        (res: any) => {
          if (res && res?.Result == 'Success' && res?.ResponseData) {
            
          }
        },
        (error: HttpErrorResponse) => {
          
        }
      );
  }

  private createAccessoriesForm(config: any): FormGroup {
    const group: any = {};

    // Add boolean controls from both arrays
    [...config.accessoriesProvided, ...config.accessoriesMissing].forEach(item => {
      group[item.value] = [false];
    });

    // Add static controls
    group['Comment'] = [''];
    group['color'] = [''];
    group['remarks'] = [''];

    return this.fb.group(group);
  }

  public GetThirdPartySettings(){
    this.configService.getSellerSettingsBySellerId({filters: "ThirdPartySettings"}).subscribe((res: any) => {
      if (res && res?.ResponseData && res?.ResponseData?.ThirdPartySettings) {
        const data = JSON.parse(res.ResponseData.ThirdPartySettings);
        const accessoriesConfig = JSON.parse(data.servicenear.accessoriesConfig);
        if(accessoriesConfig){
          this.accessoriesConfig.accessoriesProvided = accessoriesConfig.accessoriesProvided || [];
          this.accessoriesConfig.accessoriesMissing = accessoriesConfig.accessoriesMissing || [];
          
        }else{
          this.accessoriesConfig.accessoriesProvided = [];
          this.accessoriesConfig.accessoriesMissing = [];
        }

      }else{
        this.accessoriesConfig.accessoriesProvided = [];
        this.accessoriesConfig.accessoriesMissing = [];
      }

      this.jobDetailForm.addControl(
        'accessories',
        this.createAccessoriesForm(this.accessoriesConfig)
      );

    });

  }

  public changePatternOrPassword(pass: number) {
    this.pass = pass;
  }

}
